import styled from 'styled-components';
import { TopProject } from '../../types/globalTypes';
import { UpdatesItem } from './UpdatesItem';
import { TUpdatesVisualMode } from './Updates';
import { sortProjectsByAvailableDate } from '../../utils/sortProjectsByAvailableDate';

interface UpdatesListProps {
  newProjectsList: TopProject[];
  visualMode: TUpdatesVisualMode;
  onLinkClick?: () => void;
}

export const UpdatesList = ({
  newProjectsList,
  visualMode,
  onLinkClick,
}: UpdatesListProps) => {
  const projects = sortProjectsByAvailableDate(newProjectsList);

  return (
    <ListContainer>
      {projects.map((project, index) => (
        <UpdatesItem
          key={index}
          name={project.Name}
          visualMode={visualMode}
          onLinkClick={onLinkClick}
        />
      ))}
    </ListContainer>
  );
};

const ListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 35px;
`;
